import React from 'react'
import { useSelector } from 'react-redux'

// Constant
import showSecondarySidebar from '../../../../layout/MainLayout/helpers/showSecondarySidebar'

// Component
import UserInfoTab from './components/UserInfoPanel'
import LoadingModal from '../../../../components/LoadingModal'

// Services
import { REDUX } from '../../../../services/util'

const {
    reduxStoreWrapper
} = REDUX

const UserInfoMainPanel = () => {

    const uid = useSelector(reduxStoreWrapper('userHierarchy.selectedID'))
    const loading = useSelector(reduxStoreWrapper('style.loading.hierUser'))

    return (
        <>
            {
                loading ?
                    <LoadingModal />
                :
                    <UserInfoTab uid={uid}/>
            }
        </>
    )
}

export default React.memo(showSecondarySidebar(true)(UserInfoMainPanel))